<template>
  <div class="app-container">
    <van-nav-bar title="绑定企业" left-arrow  @click-left="$router.push('/mine')" />
    <van-steps :active="2">
      <van-step>输入企业全称</van-step>
      <van-step>点击"获取验证码"</van-step>
      <van-step>点击"绑定"</van-step>
    </van-steps>
    <van-form validate-first @submit="handleBindClient">
      <van-col :span="24">
        <base-textarea size="large" label="企业全称" v-model="form.client_name"
                       :showWordLimit="false"
                       :rules="[{ required: true, message: '请输入您的企业全称' }]"
        />
      </van-col>
      <van-col :span="24">
        <base-input type="digit" size="large" label="手机号" v-model="form.mobile"
                    maxlength="11" :readonly="true"
        />
      </van-col>
      <van-col :span="24">
        <base-input type="digit" size="large" label="短信验证码" v-model="form.code"
                    maxlength="6" :rules="[{ validator: validSms, message: '您输入的短信验证码有误' }]"
        >
          <template #button>
            <van-button size="small" type="primary" :disabled="!isClientValid"
                        @click="handleSendSms">{{ countdownMsg }}</van-button>
          </template>
        </base-input>
      </van-col>
      <van-col :span="24" style="text-align: center;">
        <div style="font-size: 1rem;">您好，请先绑定您的企业！</div>
        <div style="color: #ccc; font-size: 0.6rem;">
          如您在春雪登记的手机号有变更，请及时联系您的服务人员
        </div>
      </van-col>
      <van-col :span="22" :offset="1">
        <br>
        <base-button size="large" native-type="submit" :round="true">绑 定</base-button>
      </van-col>
    </van-form>
  </div>
</template>

<script>
import { preBindClient, bindClient } from '@/api/client'
export default {
  data() {
    return {
      form: {
        client_name: '',
        mobile: '',
        code: ''
      },
      countdown: this.CONST.SEND_SMS_INTERVAL,
      countdownMsg: '获取验证码'
    }
  },
  computed: {
    isClientValid() {
      return this.form.client_name && this.form.client_name.length >= 2
        && this.countdownMsg === '获取验证码'
    }
  },
  methods: {
    validSms(val) {
      return /\d{6}/.test(val)
    },
    handleSendSms() {
      preBindClient({
        client_name: this.form.client_name
      }).then(resp => {
        this.form.mobile = resp.mobile
        this.alert(`验证码已发送至 ${this.form.mobile}`)
        const timer = setInterval(() => {
          if (this.countdown === 0) {
            clearInterval(timer)
            this.countdown = this.CONST.SEND_SMS_INTERVAL
            this.countdownMsg = '获取验证码'
          } else {
            this.countdownMsg = `重新发送(${this.countdown})`
            this.countdown = this.countdown - 1
          }
        }, 1000)
      })
    },
    handleBindClient() {
      bindClient({
        code: this.form.code
      }).then(resp => {
        if (resp.success) {
          this.alert(resp.msg)
          this.$router.push('/home')
        } else {
          this.alert(resp.msg)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bind-user.vue